var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.662,
    height: 20.174,
    viewBox: "0 0 20.662 20.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(0.002 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    "data-name": "Trazado 563",
    d: "M13.259.829A9.82,9.82,0,0,1,25.533,9.214a9.766,9.766,0,0,1-.077,2.771",
    transform: "translate(-5.937 -0.5)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_564",
    "data-name": "Trazado 564",
    d: "M14.07,5.522a6.726,6.726,0,0,1,1.082-.213,7.043,7.043,0,0,1,7.664,8.562",
    transform: "translate(-6.283 -2.53)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_565",
    "data-name": "Trazado 565",
    d: "M20.116,16.093a3.773,3.773,0,0,0,.226-1.794,3.86,3.86,0,0,0-4.271-3.4,2.844,2.844,0,0,0-.61.13",
    transform: "translate(-6.875 -4.921)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_566",
    "data-name": "Trazado 566",
    d: "M17.893,16.994a.741.741,0,0,1,.2,1.188l-.007.007c-3.742,3.68-10.128,3.25-14.264-.955s-4.46-10.6-.717-14.279c.187-.184.906.265,1.032.494l2.013,4.02A1.378,1.378,0,0,1,5.8,9.214L4.492,10.243a1.083,1.083,0,0,0-.257,1.412l.352.582a12.859,12.859,0,0,0,4,4.132l1.339.927a.762.762,0,0,0,1.046-.174l1.358-1.839a1.11,1.11,0,0,1,1.381-.337Z",
    transform: "translate(-0.5 -1.528)",
    fill: "none",
    stroke: "#e0611a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.06ff77a9b5b88d9538fdf86919d47801.svg";
export { ForwardRef as ReactComponent };